<mat-form-field appearance="outline">
  <mat-label>Range</mat-label>
  <mat-select #selector (selectionChange)="optionChange($event)" [(ngModel)]="selectedOption">
    <mat-option [value]="filterForEventVolumeChart ? 'week' : 'last_week'">{{ filterForEventVolumeChart ? 'Week' : 'Last Week' }}</mat-option>
    <mat-option [value]="filterForEventVolumeChart ? 'month' : 'last_month'">{{ filterForEventVolumeChart ? 'Month' : 'Last Month' }}</mat-option>
    @if (showYearly) {
      <mat-option [value]="filterForEventVolumeChart ? 'year' : 'last_year'">{{ filterForEventVolumeChart ? 'Year' : 'Last Year' }}</mat-option>
    }
    @if (!filterForEventVolumeChart && showAllTime) {
      <mat-option value="all_time">All Time</mat-option>
    }
    @if (showCustom) {
      <mat-option value="custom" (click)="selector.open()">Custom Range</mat-option>
    }
    @if (showCustomRangeInput) {
      <div class="custom-date-picker">
        <mat-date-range-input [rangePicker]="picker" name="dateRange">
          <input matStartDate placeholder="Start" #dateRangeStart readonly>
          <input matEndDate placeholder="End" #dateRangeEnd readonly (dateChange)="onCustomDateRangeChange(dateRangeStart.value, dateRangeEnd.value)">
        </mat-date-range-input>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-date-range-picker #picker></mat-date-range-picker>
      </div>
    }
  </mat-select>
</mat-form-field>